import { customBaseQuery } from '@/lib/baseQuery';
import { CreateClientFormType } from '@/components/Shared/CreateClient';
import { ApiResponse } from '@/shared/types';
import { createApi } from '@reduxjs/toolkit/query/react';
import { WebinarContact } from '@/pages/application/pages/webinar/types/webinar-contact.type';

export const odinAppApi = createApi({
  reducerPath: 'odinAppApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    registerClient: builder.mutation<
      ApiResponse<{ email: string; phone: string }>,
      CreateClientFormType
    >({
      query: (body) => {
        return {
          url: '/v1/online-assessment/client/create',
          method: 'POST',
          body,
        };
      },
    }),
    registerClientByAdmin: builder.mutation<
      ApiResponse<{ access_token: string }>,
      CreateClientFormType
    >({
      query: (body) => {
        return {
          url: '/v1/online-assessment/client/create/admin',
          method: 'POST',
          body,
        };
      },
    }),
    getCotacts: builder.query<
      ApiResponse<{
        count: number;
        next: string | null;
        previous: string | null;
        results: {
          user_id: number;
          fullname: string | null;
          email: string;
          phone: string | null;
          first_name: string;
          last_name: string;
          created_at: string;
          hubspot_id: string | null;
        }[];
      }>,
      { page?: number; pageSize?: number; search?: string }
    >({
      query: ({ page = 1, pageSize = 10, search } = {}) => {
        const params = new URLSearchParams();
        params.set('page', String(page));
        params.set('pageSize', String(pageSize));
        if (search) params.set('search', search);
        return `/v1/online-assessment/contacts?${params.toString()}`;
      },
    }),
    getAdminLoginAsUser: builder.mutation<
      ApiResponse<{ token: string }>,
      { email: string }
    >({
      query: ({ email }) => ({
        url: 'v1/online-assessment/client/token',
        method: 'POST',
        body: { email },
      }),
    }),

    getClientTokenAsUser: builder.mutation<
      ApiResponse<{ access_token: string; refresh_token: string }>,
      { email: string }
    >({
      query: ({ email }) => ({
        url: 'v1/online-assessment/client/access/token',
        method: 'POST',
        body: { email },
      }),
    }),

    verifyExistingUser: builder.mutation<
      ApiResponse<{ exists: boolean }>,
      { email: string }
    >({
      query: ({ email }) => ({
        url: 'v1/online-assessment/verify/existing/user',
        method: 'POST',
        body: { email },
      }),
    }),
    getLenders: builder.query<ApiResponse<any>, void>({
      query: () => `/odin-admin/lender/list`,
    }),
    updateLenders: builder.mutation<ApiResponse<any>, any>({
      query: ({ id, ...body }) => ({
        url: `/odin-admin/lender/${id}`,
        method: 'PATCH',
        body,
      }),
    }),
    createWebinarContact: builder.mutation<ApiResponse<any>, WebinarContact>({
      query: (body) => ({
        url: '/v1/online-assessment/client/create/webinar/admin',
        method: 'POST',
        body,
      }),
    }),
    postPurchaseWebhook: builder.mutation<any, any>({
      query: ({ deal_id, application_id }) => ({
        url: `/odin-app-public/purchase/webhook`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-KEY': 'eDCQ_9mfRG-MtMB1YgX_wyQ6NLZrgL0lyXQxx0lDw0A',
        },
        body: {
          deal_id,
          application_id,
        },
      }),
    }),
    postRefinanceWebhook: builder.mutation<any, any>({
      query: (body) => ({
        url: `/odin-app-public/refinance/webhook`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-KEY': 'eDCQ_9mfRG-MtMB1YgX_wyQ6NLZrgL0lyXQxx0lDw0A',
        },
        body,
      }),
    }),
  }),
});

export const {
  useRegisterClientByAdminMutation,
  useRegisterClientMutation,
  useGetCotactsQuery,
  useGetAdminLoginAsUserMutation,
  useGetClientTokenAsUserMutation,
  useVerifyExistingUserMutation,
  useGetLendersQuery,
  useUpdateLendersMutation,
  useCreateWebinarContactMutation,
  usePostPurchaseWebhookMutation,
  usePostRefinanceWebhookMutation,
} = odinAppApi;
